import css from './Copyright.module.css';

const Copyright = () => {
  return (
    <div className={css.copyright_paragraph}>
      @2024, Foodies. All rights reserved
    </div>
  );
};

export default Copyright;
